export default __webpack_public_path__ + "static/media/Devansh Arya .cd6f0a18.jpg";